<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import type { PrivacyConfigType } from '@/types/privacy-config'
import { socketEmitAsync } from '@/utils/web-socket'

const userStore = useUserStore()

async function handleSetPrivacy(key: keyof PrivacyConfigType) {
  await socketEmitAsync({ type: 'setPrivacy', data: { key } })
  ElMessage.success('设置成功')
  return true
}
</script>

<template>
  <div class="set-privacy">
    <el-row :gutter="10">
      <el-col :span="12">
        <span>允许查看ID：</span>
        <el-switch v-model="userStore.privacyConfig.showId" size="small" :before-change="() => handleSetPrivacy('showId')" />
      </el-col>
      <el-col :span="12">
        <span>允许查看会员等级：</span>
        <el-switch v-model="userStore.privacyConfig.showVip" size="small" :before-change="() => handleSetPrivacy('showVip')" />
      </el-col>
      <el-col :span="12">
        <span>允许查看穿戴装备：</span>
        <el-switch v-model="userStore.privacyConfig.showEquip" size="small" :before-change="() => handleSetPrivacy('showEquip')" />
      </el-col>
      <el-col :span="12">
        <span>允许查看注册时间：</span>
        <el-switch v-model="userStore.privacyConfig.showCreated" size="small" :before-change="() => handleSetPrivacy('showCreated')" />
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped></style>
